import { useEffect, useState } from "react";
import { Button, Message } from "semantic-ui-react";
import { LoadingWrapper, ReactTable } from "../common";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchWithAuth, getCSRFToken } from "../auth";


export const AssetInspections = (props) => {

    const [columnInfo, setColumnInfo] = useState([])
    const [inspections, setInspections] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [error, setError] = useState(false)
    const navigate = useNavigate();
    const { id } = useParams()
    const statusPriority = {
        'pending':1,
        'denied':2,
        'approved':3,
        'other':4
    }


    async function getAssetInspections() {
    setLoaded(false)
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'assetinspections/', {
      headers: { 'X-CSRFToken': getCSRFToken() },
      credentials: 'include'
    })
     setLoaded(true)
     if (!resp.ok) {
         setError("Error fetching asset inspections")
         return
     }
    const respJson = await resp.json()
    const sortedInspections = respJson.sort((a,b)=>{
        const priorityA = statusPriority[a.status] || statusPriority['other']
        const priorityB = statusPriority[b.status] || statusPriority['other']
        return priorityA - priorityB;
    })

    setInspections(sortedInspections)
   }
    useEffect(() => {
        getAssetInspections()
    }, [])

    useEffect((isEdit) => {
    setColumnInfo([
      {
        Header: "Asset",
        accessor: "assetName",
       Cell: (row) => {
          return <Link
            to={`/standdown/${row.row.original.id}`}>
              {row.row.original.assetName}
          </Link>
        }
      },
      {
        Header: "Inspected By",
        accessor: (row) => row.inspectedByUserInfo?.name ?? '',
        id: "inspectedByName",
        Cell: (row) => {
            return <div>{row.row.original.inspectedByUserInfo?.name ?? ''}</div>
        }
      },
      {
        Header: "Inspection Date",
        accessor: "inspectionDate",
        Cell: (row) => {
          return row.row.original.inspectionDate
        }
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: (row) => {
          return row.row.original.status
        }
      },
      {
        Header: "Team",
        accessor: (row) => row.teamName ?? '',
        id: "teamName",
        Cell: (row) => {
          return <div>{row.row.original.teamName ?? ''}</div>
        }
      },
    ])
    }, [])
    return (
    <div>
        <LoadingWrapper loading={!loaded} text="Loading Asset Inspections">
            <div style={{width: "100%", display: "flex", justifyContent: "center", marginBottom: "1rem"}}>
                {error && <Message style={{width: "fit-content"}} negative>{error}</Message>}
            </div>
            <ReactTable
                className="channel-table"
                data={inspections}
                columns={columnInfo}
                hiddenColumns={['id']}
            />
        </LoadingWrapper>
        <Button style={{backgroundColor: "var(--delete)", color: "white"}} onClick={() => navigate(`/standdown/new`)}>Submit
            Stand-Down</Button>
    </div>
    );


};